import { useEffect, useRef, useState } from 'react';
import { NavigateProps } from 'react-router-dom';

import { ERROR_CODES } from '../../../configs';
import { FormRoutes, FormType } from '../../../libs/enums';

const ERROR_CODE_FORMAT = /^Y\d{6}$/;
const CODES = ERROR_CODES as unknown as Record<string, string | false>;

export const useLegacyPage = ({ errorCode, faq }: { errorCode?: string; faq?: string }) => {
  const isReady = useRef(false);
  const [navigateProps, setNavigateProps] = useState<NavigateProps>();

  useEffect(() => {
    const isAllowedFAQ = faq && (faq === FormType.SECURITY || faq === FormType.CONTACT);
    if (isAllowedFAQ) {
      isReady.current = true;
      // @NOTE : conditions must be refactored
      // use a helpers/utils/service to get the formtype dans formroute
      // @see https://gitlab.dev-franceconnect.fr/france-connect/formulaire-usagers/-/merge_requests/62#note_210233
      const formtype = faq === FormType.SECURITY ? FormType.SECURITY : FormType.CONTACT;
      const formroute = FormRoutes[formtype.toUpperCase() as keyof typeof FormRoutes];
      setNavigateProps({ replace: true, state: undefined, to: `/formulaire/faq/${formroute}` });
    }
  }, [faq]);

  useEffect(() => {
    if (errorCode) {
      const errorCodeRespectFormat = ERROR_CODE_FORMAT.test(errorCode);

      const isFormValueValid = CODES[errorCode] !== false;

      if (isFormValueValid && errorCodeRespectFormat) {
        isReady.current = true;
        // @NOTE : conditions must be refactored
        // use a helpers/utils/service to get the formtype dans formroute
        // @see https://gitlab.dev-franceconnect.fr/france-connect/formulaire-usagers/-/merge_requests/62#note_210233
        const formtype = CODES[errorCode] || FormType.TECHNICAL;
        const formroute = FormRoutes[formtype.toUpperCase() as keyof typeof FormRoutes];
        setNavigateProps({
          replace: true,
          state: undefined,
          to: `/formulaire/${formroute}/${errorCode}`,
        });
      }
    }
  }, [errorCode]);

  useEffect(() => {
    if (!isReady.current) {
      isReady.current = true;
      setNavigateProps({
        replace: true,
        state: { error: faq || errorCode || undefined },
        to: '/erreur',
      });
    }
  }, [errorCode, faq]);

  // http://localhost:3000/support/formulaire?error_code=Y010004&sp_name=mcp&idp_name=Yris
  // http://localhost:3000/support/formulaire?error_code=B999999&sp_name=Impot&idp_name=Ameli.fr
  return { navigateProps };
};
